// extracted by mini-css-extract-plugin
export default {"profileTxt":"index_profileTxt_G4Pq3"};